import { render, staticRenderFns } from "./WorkflowParameters.vue?vue&type=template&id=8c68f156&scoped=true&"
import script from "./WorkflowParameters.vue?vue&type=script&lang=js&"
export * from "./WorkflowParameters.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowParameters.vue?vue&type=style&index=0&id=8c68f156&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c68f156",
  null
  
)

export default component.exports